import styled from "styled-components";

// AccordionSection
export const AccordionContent = styled.div(({ theme }) => ({
  marginTop: "32px",
  [theme.breakpoint.lg()]: {
    display: "flex",
    gap: "64px",
    marginTop: "40px",
  },
}));

export const AccordionItem = styled.div(({ theme }) => ({
  width: "100%",
  [theme.breakpoint.lg()]: {
    width: "50%",
  },
}));

// ActivateMyInsuranceSection
export const ActivateMyInsuranceContent = styled.div(() => ({
  marginTop: "64px",
  display: "flex",
  alignItems: "center",
  gap: "64px",
  alignSelf: "stretch",
}));

export const ActivateMyInsuranceItem = styled.div(() => ({
  display: "flex",
}));
